import React, { createContext, useContext, useState, ReactNode } from 'react';

export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LoggerContextType {
  logLevel: LogLevel;
  setLogLevel: (level: LogLevel) => void;
}

const LoggerContext = createContext<LoggerContextType | undefined>(undefined);

export const LoggerProvider = ({ children, initialLevel = 'info' }: { children: ReactNode; initialLevel?: LogLevel }) => {
  const [logLevel, setLogLevel] = useState<LogLevel>(initialLevel);
  return (
    <LoggerContext.Provider value={{ logLevel, setLogLevel }}>
      {children}
    </LoggerContext.Provider>
  );
};

export const useLoggerContext = () => {
  const ctx = useContext(LoggerContext);
  if (!ctx) throw new Error('useLoggerContext must be used within a LoggerProvider');
  return ctx;
};
